<div class="notifications">
  <sc-dropdown class="notifications__dropdown" (openEvent)="_onDropdown($event)" (closeEvent)="_onDropdown($event)" [opened]="isOpen" #dropdown>
    <ng-template scDropdownBtnItemTmp let-opened="opened">
      <a class="notifications__dropdown__btn" (click)="dropdown.handleClick($event)">
        <sc-icon class="notifications__dropdown__btn-icon" icon="icon-bell"></sc-icon>
        @if (unreadNotificationsCount > 0) {
          <div class="notifications__dropdown__btn-number">{{
          unreadNotificationsCount }}</div>
        }
      </a>
    </ng-template>
    <ng-template scDropdownListTmp let-opened="opened">
      @if (opened) {
        <div class="notifications__dropdown__menu" [class.notifications__dropdown__menu--open]="opened" (scClickOutside)="dropdown.handleClickOutside($event)" [@notificationAnimation]="opened">
          <div class="notifications__dropdown__menu__container">
            <div class="notifications__dropdown__menu__main notifications__scrollbar">
              @if (notifications.length > 0) {
                <ul class="notifications__dropdown__menu__main__list">
                  @for (group of notifications | scGroupBy: 'dateGroup'; track group.id) {
                    <li class="notifications__dropdown__menu__main__list__item-group-title">{{ group.key }}</li>
                    @for (item of group.value; track $index; let last = $last) {
                      <li class="notifications__dropdown__menu__main__list__item" [ngClass]="{'last': last}" [class.notifications__dropdown__menu__main__list__item--readed]="item.isRead" (click)="_onNotificationClick(item)">
                        @if (item.notificationData) {
                          <div class="notifications__dropdown__menu__main__list__item__header">
                            @if (item.notificationData.ReceptionDate) {
                              <span class="notifications__dropdown__menu__main__list__item__header-date">
                                {{ getDateLabel(item.notificationData.ReceptionDate) }}
                              </span>
                            }
                            <span class="notifications__dropdown__menu__main__list__item__header-separator">&nbsp;-&nbsp;</span>
                            @if (item.notificationData.Risk) {
                              <span class="notifications__dropdown__menu__main__list__item__header-desc text-truncate">
                                {{ item.notificationData.Risk.PlateNumber }},
                                {{ item.notificationData.Risk.Brand }}
                                {{ item.notificationData.Risk.Model }}
                                {{ item.notificationData.Risk.Version }}
                              </span>
                            }
                          </div>
                        }
                        @if (item.notificationType) {
                          <div class="notifications__dropdown__menu__main__list__item-title">{{
                          item.notificationType }}</div>
                        }
                        @if (item.notificationData && item.notificationData.Description) {
                          <div class="notifications__dropdown__menu__main__list__item-desc">{{
                          item.notificationData.Description }}</div>
                        }
                        @if (item.actions && item.actions.length > 0) {
                          <div class="notifications__dropdown__menu__main__list__item-actions">
                            <ul class="notifications__dropdown__menu__main__list__item-actions__list">
                              @for (action of item.actions | scFilter: (actionClick !== null || actionClick !== '') && (label !== null || label !== ''); track action) {
                                <li class="notifications__dropdown__menu__main__list__item-actions__list__item">
                                  <a class="notifications__dropdown__menu__main__list__item-actions__list__item-link" (click)="_onNotificationActionClick(item, action)">
                                    {{ action.label }}
                                  </a>
                                </li>
                              }
                            </ul>
                          </div>
                        }
                      </li>
                    }
                  }
                  @if (notifications.length > 0 && hasMoreItems) {
                    <li class="notifications__dropdown__menu__main__list__item__more-items">
                      <sc-button size="small" type="link" (onClick)="getNotifications()" [loading]="loadingNotifications">Cargar más</sc-button>
                    </li>
                  }
                </ul>
              }
              @if (notifications.length === 0) {
                <div class="notifications__dropdown__menu__main__empty-state">
                  @if (!loadingNotifications) {
                    <div class="notifications__dropdown__menu__main__empty-state-msg">Sin
                    notificaciones</div>
                  }
                  @if (loadingNotifications) {
                    <sc-icon class="notifications__dropdown__menu__main__empty-state-loading" icon="fa-duotone fa-spinner-third"></sc-icon>
                  }
                </div>
              }
            </div>
            <!-- Footer -->
            <div class="notifications__dropdown__menu__footer"></div>
          </div>
        </div>
      }
    </ng-template>
  </sc-dropdown>
</div>
